import { useToast } from 'components/Toast';

import useTranslations from 'context/Translations';
import React from 'react';
import Toast from 'skapa/Toast';

const ToastNotifications: React.FC = () => {
    const { toast, removeToast } = useToast();
    const translate = useTranslations();
    const onCloseRequest = () => {
        removeToast();
    };

    return (
        <Toast
            data-testid={toast?.name}
            text={toast?.text ?? ''}
            actionButtonText={toast?.actionButtonText}
            actionClick={toast?.actionClick ?? (() => {})}
            isOpen={!!toast}
            onCloseRequest={onCloseRequest}
            {...(toast?.role ? { role: toast.role } : {})}
            ariaLabel={toast?.text ?? ''}
            ariaLabelCloseBtn={translate('CLOSE')}
        />
    );
};

export default ToastNotifications;
